import React, { Fragment } from "react";
import Heading from "../../../Dashboard/components/Resources/Heading";
import withStyling from "../../hocs/withStyling";
import { Mui } from "@osu/react-ui";
import { LEARN_MORE } from "../../../util/constants";
import { linkablePathValues } from "../../../Routes/paths";
import { Link } from "react-router-dom";
import ResourceList from "../Lists/Resources";

function Resources({ show }) {
  return (
    <Fragment>
      <Heading>Resources</Heading>
      <ResourceList show={show} />
      <Mui.Divider />
      <Mui.Button
        variant="outlined"
        className="margin-top-2 align-self-end"
        to={linkablePathValues.wellness}
        component={Link}
      >
        {LEARN_MORE}
        <Mui.Typography component="span" variant="srOnly"> Wellness Resources</Mui.Typography>
      </Mui.Button>
    </Fragment>
  );
}

export default withStyling(Resources);
